import { render, staticRenderFns } from "./beveledge.vue?vue&type=template&id=10f80386"
import script from "./beveledge.vue?vue&type=script&lang=js"
export * from "./beveledge.vue?vue&type=script&lang=js"
import style0 from "./beveledge.vue?vue&type=style&index=0&id=10f80386&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports